<div class="post-container">
	<div class="titleContainer">
		<h2>Recent Posts</h2>
	</div>
	<portals-loading [showIf]="formLoading">
		<div class="infoContainer">
			<div class="classCard" *ngFor="let post of data" fxLayout="row" fxLayoutAlign="space-between start">
				<div style="width: auto">
					<div class="border-2 border-solid border-portals-accent-900 rounded-full mr-4">
						<img [src]="post.channel_img_url || 'assets/images/default.png'" class="avatarimg border-2 border-solid border-portals-primary-900 rounded-full" alt="channel-thumbnail" />
					</div>
				</div>
				<div style="width: 100%">
					<div class="cardTitle">
						<div>{{ post.title | titlecase }}</div>
					</div>
					<div style="display: flex; flex-direction: row; justify-content: flex-start">
						<div class="header-label-wrapper" style="margin-right: 10px; width: 70%; text-overflow: clip; display: flex; flex-direction: column; align-items: flex-start">
							<div>
								<span style="color: gray; font-weight: 500; font-size: 12px">Posted On</span>
								<div style="font-size: 14px; color: #491176">
									<b>
										{{ post.created_at | date : 'EEEE MMM dd Y' }}
									</b>
									{{ post.created_at | date : 'HH:MM a' }}
								</div>
							</div>
						</div>
						<div class="summary-content" style="display: flex; flex-direction: column">
							<span>
								<b style="color: var(--portals-theme-primary-text)" class="summary">
									{{ post?.sent_to | count }}
								</b>
								<span [ngPlural]="post?.sent_to || 0">
									<ng-template ngPluralCase="=1">recipient</ng-template>
									<ng-template ngPluralCase="other">recipients</ng-template>
								</span>
							</span>
							<span>
								<b style="color: var(--portals-theme-primary-text)" class="summary">
									{{ post?.view_count | count }}
								</b>
								<span [ngPlural]="post?.view_count || 0">
									<ng-template ngPluralCase="=1">view</ng-template>
									<ng-template ngPluralCase="other">views</ng-template>
								</span>
							</span>
						</div>
					</div>
				</div>
				<hr />
			</div>
		</div>
	</portals-loading>
</div>
